import { getBuildId } from "helpers/commonUtils";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const MissingKeyExtractor = {
  type: "logger",
  missingKeys: {},
  log: function log(args) {
    if (args.includes("i18next::translator: missingKey")) {
      if (!Object.keys(this.missingKeys).includes(args[4])) {
        Object.assign(this.missingKeys, { [args[4]]: args[4] });
      }
      console.log(this.missingKeys);
    } else {
      this.output("log", args);
    }
  },
  warn: function warn(args) {
    this.output("warn", args);
  },
  error: function error(args) {
    this.output("error", args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  },
};

const BUILD_ID = getBuildId();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(MissingKeyExtractor).init({
    debug: false,
    backend: {
      loadPath: `/locales/{{lng}}${BUILD_ID ? "." + BUILD_ID : ""}.json`,
    },
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "no", "fi"],
  });

export default i18n;
